import { render, staticRenderFns } from "./PaginaManutencao.vue?vue&type=template&id=42cb6bca&scoped=true&"
import script from "./PaginaManutencao.vue?vue&type=script&lang=js&"
export * from "./PaginaManutencao.vue?vue&type=script&lang=js&"
import style0 from "./PaginaManutencao.vue?vue&type=style&index=0&id=42cb6bca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cb6bca",
  null
  
)

export default component.exports